// DIA - MES - AÑO
let formatterDate = (dateToFormatter) => {
  let dateResolve = new Date(dateToFormatter);
  dateResolve = `${dateResolve.getDate()}/${
    dateResolve.getMonth() + 1 < 10
      ? "0" + (Number(dateResolve.getMonth()) + 1)
      : Number(dateResolve.getMonth()) + 1
  }/${dateResolve.getFullYear()}`;
  return dateResolve;
};
export { formatterDate };
